@if (vm$ | async; as vm) {
	<section class="flex container">
		@if (vm.errorContent.errorName !== errorContentName.INVALID_TAX_FOLDER_PASSWORD) {
			<app-header></app-header>
		}

		<div class="content flex coverage">
			<div class="wrap-icon">
				<img [src]="vm.errorContent.asset" alt="error image" />
			</div>
			<div class="wrap-text flex">
				<div class="title">
					<p class="text">{{ vm.errorContent.title }}</p>
				</div>
				<div class="description">
					<p class="text">
						{{ vm.errorContent.description }}
					</p>
				</div>
			</div>
			<div class="wrap-button flex">
				<button
					bciWkButtonPrimary
					(click)="onButtonActionHandler(vm.errorContent, vm.customerData?.companyRut)"
					[innerHTML]="vm.errorContent.button.text"
				></button>
			</div>
		</div>

		@if (vm.errorContent.errorName !== errorContentName.INVALID_TAX_FOLDER_PASSWORD) {
			<app-footer></app-footer>
		}
	</section>
}
